/* carrito.js — agregar y VER el carrito sin salir de la página.

   Ver el carrito abre un cajón encima de donde estás. Solo el PAGO es otra pantalla, que es
   como debe ser: el checkout es de Shopify y ahí no se experimenta.

   Progressive enhancement de verdad: sin JS, el botón del carrito es un enlace normal a /cart
   y los formularios de producto envían como siempre. Nunca se rompe la venta; solo se pierde
   la comodidad. */
(function () {
  var K = window.KAWAII || {};

  /* ── EL UMBRAL LO MANDA LA APP, NO EL TEMA ────────────────────────────────────────────────
     Alfredo, 2026-08-14: *"hice el cambio de envío gratis a 999 pero en la página no se
     actualiza, se quedó en 1000"*.

     El número vivía DOS VECES: en la app —que es quien de verdad da el envío gratis en el
     checkout— y en un ajuste del tema, que es quien pinta esta barra. Dos copias del mismo dato
     siempre acaban diciendo cosas distintas, y la que ve la clienta era justo la que nadie
     recordaba cambiar. Peor que un número viejo: una barra que promete un envío gratis que el
     pago no va a cumplir.

     Se pregunta UNA vez por carga y se cachea en `sessionStorage`: la barra se repinta con cada
     cambio del carrito, y no vamos a llamar a otro servidor en cada suma.

     Si la app no contesta, se queda el ajuste del tema: una barra vieja es mejor que ninguna. */
  var ENDPOINT_APP = 'https://envios-bakabaka.fly.dev';
  (function alineaUmbral() {
    if (!window.fetch || !K.envioGratis) return;
    var cache = null;
    try { cache = JSON.parse(sessionStorage.getItem('bkb_envio_gratis') || 'null'); }
    catch (e) { cache = null; }
    try {
      var _esc0 = JSON.parse(sessionStorage.getItem('bkb_escalones') || 'null');
      if (_esc0 && _esc0.length) K.escalones = _esc0;
    } catch (e) { /* modo privado */ }
    function repintar() {
      if (typeof carritoActual !== 'undefined' && carritoActual) {
        try { pintarEnvio(carritoActual); } catch (e) { /* la barra no tumba el carrito */ }
      }
    }
    function aplica(eg) {
      if (!eg || typeof eg !== 'object') return;
      // El umbral del tema está en CENTAVOS (lo convierte Liquid); el de la app, en pesos.
      var desde = Number(eg.desde || 0);
      if (eg.activo && desde > 0) {
        K.envioGratis.activo = true;
        K.envioGratis.umbral = Math.round(desde * 100);
      } else if (eg.activo === false) {
        // Apagarlo en la app también cuenta: seguir prometiéndolo sería la peor de las dos copias.
        K.envioGratis.activo = false;
      }
      // Se repinta con el carrito que ya está en memoria: llegar tarde no puede dejar la barra
      // con el número viejo hasta que la clienta toque algo. `carritoActual` lo llena `pintar`;
      // si la respuesta llega antes que el primer /cart.js, no hay nada que repintar todavía y
      // el umbral nuevo lo usará esa primera pintada.
      if (typeof carritoActual !== 'undefined' && carritoActual) {
        try { pintarEnvio(carritoActual); } catch (e) { /* la barra no tumba el carrito */ }
      }
    }
    if (cache) { aplica(cache); return; }
    fetch(ENDPOINT_APP + '/puente')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c) return;
        // LA ESCALERA, ANTES QUE EL UMBRAL SUELTO: si hay peldaños, ellos mandan (y el envío
        // gratis es el último). Se guarda con el resto para que una recarga no la pierda.
        if (c.escalones && c.escalones.length) {
          K.escalones = c.escalones;
          try { sessionStorage.setItem('bkb_escalones', JSON.stringify(c.escalones)); }
          catch (e) { /* modo privado */ }
        }
        if (!c.envio_gratis) { if (K.escalones) repintar(); return; }
        try { sessionStorage.setItem('bkb_envio_gratis', JSON.stringify(c.envio_gratis)); }
        catch (e) { /* modo privado: se pregunta otra vez, y ya */ }
        aplica(c.envio_gratis);
      })
      .catch(function () { /* sin app: manda el ajuste del tema */ });
  })();

  // ── dinero: se respeta el formato de la tienda, no se inventa ────────────
  function formatoDinero(centavos) {
    var f = K.dinero || '${{amount}}';
    var n = (centavos || 0) / 100;
    function sep(v, miles, dec, decimales) {
      var p = v.toFixed(decimales).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return decimales ? p.join(dec) : p[0];
    }
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sep(n, '.', ',', 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, sep(n, '.', ',', 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep(n, ',', '.', 0))
      .replace(/\{\{\s*amount\s*\}\}/g, sep(n, ',', '.', 2));
  }

  // Los títulos vienen de la tienda, no de aquí: un producto llamado Peluche "nube" o un
  // nombre con < rompería el markup si se inyectara crudo.
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function contador(n) {
    [].forEach.call(document.querySelectorAll('.carrito-num'), function (e) {
      e.textContent = n;
      e.classList.remove('late'); void e.offsetWidth; e.classList.add('late');
    });
  }

  // ── envío gratis: cuánto falta ───────────────────────────────────────────
  // Shopify NO deja leer el umbral real desde el tema: no hay objeto Liquid, ni metafield, ni
  // API de storefront que exponga la condición de la tarifa (leído en la doc, 2026-07-27). Lo
  // único que dice la verdad son las tarifas calculadas para una DIRECCIÓN, y en el cajón no
  // hay dirección. Así que el umbral es una COPIA que pone Alfredo en los ajustes, y esta
  // función se calla en cuanto no puede sostener lo que diría.
  //
  // Se compara contra `total_price` —«after discounts have been applied»—, que es lo que
  // Shopify mide para la tarifa: «shipping rates based on the total value of the cart after
  // applying discounts». `items_subtotal_price` NO sirve: solo descuenta lo de LÍNEA, así que
  // con una promoción de pedido activa la barra prometería el envío antes de tiempo.
  //
  // Todo en CENTAVOS y con enteros. En pesos flotantes la barra se queda en 99.99% para
  // siempre y el «te faltan $0» no desbloquea nunca.
  //
  // Cuando se calla, DICE POR QUÉ. Callarse tiene cuatro motivos distintos y desde fuera son
  // idénticos: sin el motivo, un medidor no puede distinguir «se calló porque debía» de «se
  // rompió», y una barra rota se leería como una barra prudente.
  /* ── LA ESCALERA DE ENVÍO ──────────────────────────────────────────────────────────────
     Alfredo, 2026-08-20: *"menos de $499 → $180 · $499 a $898 → $99 · $899 o más → gratis"*.

     No son tres promociones: es UNA escalera, y cada peldaño es una razón para subir otro. Por
     eso la barra no puede hablar solo del último —«te faltan $700 para envío gratis» desanima a
     quien lleva $300— sino del SIGUIENTE, que es el que está a su alcance ahora mismo.

     La escalera la manda la app, la misma con la que se cobra. Dos copias del mismo número es
     cómo la barra acaba prometiendo un precio que el pago no cumple. */
  /* LA META es el último peldaño: el envío gratis, si lo hay. La barra entera se mide contra
     ella, así que un carrito de $600 en una escalera que acaba en $849 va por el 71% de SU
     carrera — no por «la mitad del tramo del medio», que no significa nada para quien compra. */
  function metaDe(esc) {
    return Number((esc[esc.length - 1] || {}).desde || 0) * 100;
  }
  function pctDe(total, meta) {
    if (!(meta > 0)) return 100;      // escalera de un solo peldaño: no hay carrera que correr
    return Math.max(0, Math.min(100, Math.round(total * 100 / meta)));
  }
  /* EL MATERIAL DE CADA PELDAÑO. Alfredo, 2026-08-20: *"el primero envío 180 rosa normal, el
     envío en 149 oro brillando, el envío en 98 diamante destello, el escalón de envío gratis
     puede ser fuego"*.

     Sale de la POSICIÓN, no del precio: él puede mover los montos en el panel cuantas veces
     quiera y la escalera sigue subiendo de material sola. Atarlo a «149 es oro» obligaría a tocar
     el tema cada vez que cambiara una cifra — y el día que se le olvidara, un peldaño se quedaría
     sin premio sin que nadie se enterara.

     El fuego es del ÚLTIMO, y solo si es gratis: es la meta. Si su escalera no acabara en cero,
     el último sería diamante — arder por un envío que aún se paga promete algo que no hay. */
  function materialDe(esc, i) {
    if (i <= 0) return 'rosa';
    if (i >= esc.length - 1) return Number(esc[i].precio || 0) <= 0 ? 'fuego' : 'diamante';
    return i === 1 ? 'oro' : 'diamante';
  }

  /* LAS PARADAS, con su sitio exacto en el riel. El primer peldaño no es una parada: es la
     salida, y dibujar una marca en el cero solo dice «no has empezado». */
  function hitosDe(esc, total) {
    var meta = metaDe(esc), out = [];
    for (var i = 1; i < esc.length; i++) {
      var desde = Number(esc[i].desde || 0) * 100;
      out.push({ pct: pctDe(desde, meta), desde: desde, precio: Number(esc[i].precio || 0),
                 hecho: total >= desde, indice: i, tipo: materialDe(esc, i) });
    }
    return out;
  }

  function porEscalones(c) {
    var esc = K.escalones;
    if (!esc || !esc.length) return null;
    var total = c.total_price || 0;         // en centavos, como todo lo de /cart.js
    var actual = esc[0], siguiente = null;
    for (var i = 0; i < esc.length; i++) {
      var desde = Number(esc[i].desde || 0) * 100;
      if (total >= desde) actual = esc[i];
      else { siguiente = esc[i]; break; }
    }
    var precioAhora = Number(actual.precio || 0);
    // EL DESCUENTO TIENE QUE VERSE. Alfredo, 2026-08-20: *"no veo el descuento en la barra de
    // progreso, tenemos que jugar con la estimulación del cliente"*. Decir solo «te faltan $199»
    // cuenta el trabajo que le queda y esconde el premio que YA se ganó: quien lleva $600 pagaba
    // $149 y ahora paga $99, y sin verlo no tiene forma de saber que subir de peldaño funcionó.
    // El precio base es el del primer peldaño, que es lo que pagaría un carrito de $1.
    var precioBase = Number((esc[0] || {}).precio || 0);
    var ahorro = Math.max(0, precioBase - precioAhora);
    if (!siguiente) {
      // Está en el último peldaño: o es gratis, o es lo más barato que hay. No queda nada que
      // prometer, así que la barra celebra en vez de pedir.
      return { logrado: precioAhora <= 0, pct: 100, falta: 0, total: total, base: total,
               umbral: total, precioAhora: precioAhora, precioSiguiente: null, escalera: true,
               precioBase: precioBase, ahorro: ahorro, peldanos: esc,
               hitos: hitosDe(esc, total), meta: metaDe(esc), indice: esc.length - 1 };
    }
    var umbral = Number(siguiente.desde || 0) * 100;
    var anterior = Number(actual.desde || 0) * 100;
    return {
      falta: Math.max(0, umbral - total),
      logrado: false,
      total: total, base: total, umbral: umbral,
      precioAhora: precioAhora,
      precioSiguiente: Number(siguiente.precio || 0),
      escalera: true, precioBase: precioBase, ahorro: ahorro, peldanos: esc,
      hitos: hitosDe(esc, total), meta: metaDe(esc), indice: esc.indexOf(actual),
      /* UNA SOLA CARRERA, CON PARADAS. Alfredo, 2026-08-20: *"en lugar de reiniciar quiero que la
         barra tenga como check point para llegar al envío gratis"*.

         Ayer el avance se medía dentro del tramo y se vaciaba al cruzar un peldaño. Visto en su
         tienda, eso castiga justo al que acaba de ganar: sube de $498 a $499, consigue el
         descuento… y la barra se le queda vacía otra vez. La recompensa y el castigo llegaban en
         el mismo instante.

         Ahora la barra mide la carrera ENTERA —de $0 a la meta— y los peldaños son paradas
         marcadas sobre ella. Lo que se avanzó no se pierde nunca, y el premio se ve venir desde
         lejos porque su marca ya está dibujada en el riel. */
      pct: pctDe(total, metaDe(esc))
    };
  }

  function envioGratis(c) {
    var E = K.envioGratis;
    // Con escalera puesta, manda la escalera: el envío gratis suelto es su último peldaño.
    var esc = porEscalones(c);
    if (esc) {
      var enviableE = false;
      for (var j = 0; c.items && j < c.items.length; j++) {
        if (c.items[j].requires_shipping) { enviableE = true; break; }
      }
      return enviableE ? esc : { callada: 'nada-que-enviar' };
    }
    if (!E || !E.activo) return { callada: 'apagada' };
    if (!(E.umbral > 0)) return { callada: 'sin-umbral' };    // sin número no se promete nada
    // Otra divisa: el umbral está en la de la tienda y con Markets las condiciones se declaran
    // en moneda local — no son una conversión. Comparar pesos contra dólares es mentir seguro.
    if (E.moneda && c.currency && c.currency !== E.moneda) return { callada: 'otra-moneda' };
    var enviable = false;
    for (var i = 0; c.items && i < c.items.length; i++) {
      if (c.items[i].requires_shipping) { enviable = true; break; }
    }
    if (!enviable) return { callada: 'nada-que-enviar' };
    // SE COMPARA CONTRA EL TOTAL QUE EL CLIENTE VE. Alfredo, 2026-07-28: *"el total con envío
    // gratis debe ser con IVA, porque si no el cliente se confunde"*. Y es la regla correcta de
    // interfaz: quien lee «Total $1,047.60» junto a «te faltan $112.40» no tiene forma de cuadrar
    // los dos números si el umbral vive en otra moneda —una sin impuesto que él no ve en ningún
    // lado—. Una cifra que el usuario no puede ver no puede explicar nada.
    //
    // El impuesto NO se descuenta aquí: el umbral del tema YA está expresado en lo que el cliente
    // ve. Eso mueve el trabajo a un sitio mejor — un número, puesto una vez, comprobado contra su
    // propio checkout. Antes el tema hacía la conversión y había que confiar en una tasa y en una
    // regla de Shopify que no pudimos verificar; ahora la referencia es su tienda, que es la
    // única autoridad que no se equivoca sobre sí misma.
    var visible = c.total_price || 0;
    var base = visible;
    // Lo que falta se compara SIN impuesto, pero se le dice al cliente CON impuesto: él va a
    // añadir productos a los precios que ve. Decirle «te faltan $100» cuando en realidad tiene
    // que meter $116 de producto es quedarse corto otra vez, solo que por el otro lado.
    var falta = Math.max(0, E.umbral - base);
    // ¿ES EL CUPÓN EL QUE LO DEJÓ CORTO? Alfredo, 2026-07-28, con su carrito delante: productos
    // $1,164, cupón −$116.40, total $1,047.60 → *"se completó los mil pero no me da el envío
    // gratis"*. Y tiene toda la razón en quejarse: llegó a los mil y su propio premio se los
    // quitó. Que la barra diga «te faltan» a secas parece un error de la tienda; decir POR QUÉ
    // convierte un enojo en una decisión. Se calcula, no se supone: solo se dice cuando sin el
    // descuento SÍ alcanzaría.
    var d = descuentoDe(c);
    var porElCupon = d.hay && base < E.umbral && (visible + d.monto) >= E.umbral;
    return { falta: falta, logrado: falta === 0, total: visible, base: base, umbral: E.umbral,
             porElCupon: porElCupon,
             pct: Math.max(0, Math.min(100, Math.round(base * 100 / E.umbral))) };
  }

  // ── LA PROMESA LA DA SHOPIFY, NO NUESTRA CUENTA ─────────────────────────
  // Alfredo, 2026-07-28: *"la barra de envío debe de estar cableada con el costo de envío de
  // shopify para solo hacer una modificación"*. Tenía toda la razón: mientras el tema tradujera
  // números —umbral con IVA, umbral sin IVA, una regla de Shopify que no pudimos verificar— había
  // dos sitios que mantener y una hipótesis en medio. Y una promesa que se calcula puede
  // equivocarse; una que se pregunta, no.
  //
  // `/cart/shipping_rates.json` devuelve las tarifas REALES de este carrito, calculadas por
  // Shopify con sus propias reglas de Envíos. Si entre ellas hay una de $0, hay envío gratis. Es
  // el mismo dato que verá en el pago, no una aproximación.
  //
  // Qué NO hace: reemplazar el umbral. Para decir «te faltan $X» hace falta un número, y Shopify
  // no lo publica. El umbral del tema se queda para ESO —una estimación que motiva— y pierde la
  // única parte que podía hacer daño: afirmar que ya hay envío gratis. Si Shopify dice que sí, se
  // dice que sí aunque el umbral no llegue; si dice que no, no se promete aunque el umbral sobre.
  //
  // Coste: una petición por carrito distinto, guardada en memoria. Sin dirección se usa el CP que
  // la persona ya escribió en el panel de envío; si no hay ninguno, no se pregunta y la barra se
  // comporta como antes — nunca se rompe por esto.
  var CLAVE_CP = 'kawaii_cp';
  var respuestas = {}, pidiendo = {};

  function cpGuardado() {
    try { return localStorage.getItem(CLAVE_CP) || ''; } catch (e) { return ''; }
  }

  function preguntarEnvio(c, alSaber) {
    var cp = cpGuardado();
    if (!cp || !c || !c.item_count) return;
    var llave = cp + ':' + c.total_price;
    // Si ya está la respuesta NO se avisa: quien llama lee la caché por su cuenta, y avisar aquí
    // hacía que el repintado volviera a preguntar, que volviera a avisar… recursión infinita
    // escondida dentro de una promesa, así que ni siquiera salía como error en la consola. El
    // aviso existe solo para la respuesta NUEVA, que es la única que cambia algo.
    if (llave in respuestas) return;
    if (pidiendo[llave]) return;
    pidiendo[llave] = true;
    var q = '?shipping_address%5Bcountry%5D=Mexico'
          + '&shipping_address%5Bzip%5D=' + encodeURIComponent(cp);
    fetch('/cart/shipping_rates.json' + q, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var tarifas = d && d.shipping_rates;
        if (!tarifas) return;                       // Shopify no supo: se calla, no se inventa
        var gratis = tarifas.some(function (t) { return parseFloat(t.price) === 0; });
        respuestas[llave] = { gratis: gratis, tarifas: tarifas };
        alSaber(respuestas[llave]);
      })
      .catch(function () { })
      .then(function () { delete pidiendo[llave]; });
  }

  // Se pinta por CLASE, no por id: el mismo trozo vive a la vez en el cajón y en la página del
  // carrito, y los dos tienen que decir lo mismo tras cada cambio de cantidad.
  // Último recurso si alguien vacía el campo en el editor. El valor de fábrica NO vive aquí:
  // viaja en config/settings_data.json. Aquí está solo para que un campo en blanco deje una
  // barra sin texto en vez de una barra muda.
  var TEXTO_FALTA = 'Te faltan {falta} para el envío gratis 🚚';
  var TEXTO_CERCA = '¡Ya casi! Te faltan {falta} 🎉';
  var TEXTO_LOGRADO = '¡Ya llevas envío gratis! 🎉';
  // Este NO es configurable a propósito: solo aparece en un caso muy concreto —el descuento dejó
  // el total por debajo del mínimo— y explicarlo mal es peor que no explicarlo. El cliente tiene
  // que entender que no es un error de la tienda ni un capricho: su cupón bajó el total.
  var TEXTO_POR_CUPON = 'Tu cupón bajó el total: te faltan {falta} para el envío gratis 🚚';
  // Cuando Shopify dice que todavía no hay envío gratis pero nuestra cuenta creía que sí, no se
  // inventa una cifra: se dice lo único que se sabe con certeza. Mejor un «ya casi» sin número
  // que un número inventado, que es lo que rompe la confianza en el pago.
  var TEXTO_CASI_SIN_CIFRA = '¡Ya casi! Sigue sumando para el envío gratis 🚚';

  // ¿Está este trozo dentro de algo escondido? En la página del carrito hay DOS barras (la del
  // cajón y la de la página) y solo una está a la vista; la otra no debe cantarle nada a nadie.
  function tapado(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      if (n.hidden) return true;
    }
    return false;
  }

  /* ── LOS PELDAÑOS, A LA VISTA ────────────────────────────────────────────────────────
     Alfredo, 2026-08-20: *"no veo el descuento en la barra de progreso, tenemos que jugar con la
     estimulación del cliente"*.

     Una barra que solo dice «te faltan $199» le cuenta la deuda y le esconde el premio. El
     descuento ya ganado es lo único que prueba que subir de peldaño sirve — y sin verlo, el
     siguiente peldaño es una promesa más de una tienda cualquiera.

     Por eso la escalera entera se pinta: lo que pagaba TACHADO, lo que paga AHORA, y lo que le
     espera. Tres cifras que se leen de un vistazo y que además explican la barra: sin ellas, el
     avance dentro del tramo es un porcentaje de algo que no está en pantalla.

     Se construye desde el JS y no desde Liquid a propósito: la escalera la manda la app —puede
     tener dos peldaños o cuatro— y un marcado fijo tendría que adivinar cuántos. Y son los mismos
     números con los que se cobra: aquí no se recalcula ninguno. */
  function pintarPeldanos(b, est) {
    var fila = b.querySelector('.envio-pasos');
    if (!fila) {
      fila = document.createElement('div');
      fila.className = 'envio-pasos';
      // Decorativo para quien no ve: el mensaje y el `aria-valuetext` ya dicen lo mismo en una
      // frase. Leer «149 99 gratis» suelto no informa, interrumpe.
      fila.setAttribute('aria-hidden', 'true');
      b.appendChild(fila);
    }
    var esc = est.peldanos || [];
    var firma = esc.map(function (e) { return e.desde + ':' + e.precio; }).join('|')
              + '@' + est.precioAhora;
    if (fila.getAttribute('data-firma') === firma) return;   // nada cambió: no se repinta
    fila.setAttribute('data-firma', firma);
    fila.textContent = '';
    for (var i = 0; i < esc.length; i++) {
      var precio = Number(esc[i].precio || 0);
      var desde = Number(esc[i].desde || 0) * 100;
      var ch = document.createElement('span');
      ch.className = 'envio-paso ' + (desde > est.total ? 'es-meta'
                     : precio === est.precioAhora ? 'es-ahora' : 'es-hecho');
      ch.textContent = precio > 0 ? formatoDinero(precio * 100) : 'GRATIS';
      fila.appendChild(ch);
    }
    b.setAttribute('data-ahorro', est.ahorro || 0);
  }

  /* ── LAS PARADAS EN EL RIEL, Y EL TRONIDO ────────────────────────────────────────────
     Alfredo, 2026-08-20: *"la barra rosa normal está bien, pero en lugar de reiniciar quiero que
     la barra tenga como check point para llegar al envío gratis. Si llega a monto de en medio se
     debe de tronar como si fuera oro la barra. Y si llega al envío gratis como si fuera un
     diamante."*

     Tres materiales, tres momentos: rosa mientras corre, ORO al cruzar el peldaño de en medio,
     DIAMANTE al llegar al envío gratis. El material se queda puesto —es lo que ganó, no un
     parpadeo— y el tronido pasa UNA vez, en el instante de cruzar.

     Que suceda una sola vez es la mitad del trabajo: esta barra se repinta con cada cambio de
     cantidad y con cada respuesta de Shopify. Sin memoria, el oro reventaría cinco veces
     seguidas y dejaría de ser un premio para volverse un tic. Por eso se recuerda el peldaño más
     alto ya celebrado, y se guarda en `sessionStorage` para que recargar la página tampoco lo
     repita. */
  var CLAVE_HITO = 'kawaii_hito';
  function hitoCelebrado() {
    try { return parseInt(sessionStorage.getItem(CLAVE_HITO) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function guardarHito(i) {
    try { sessionStorage.setItem(CLAVE_HITO, String(i)); } catch (e) { }
  }

  /* ── LOS CHECKPOINTS, DIBUJADOS ──────────────────────────────────────────────────────
     Alfredo, 2026-08-20: *"quiero que los efectos sean más estéticos y llamativos, quiero que los
     checkpoint sean diseños svg de referencia"*.

     Un punto de color no dice qué premio hay al llegar: hay que leer el texto para saberlo. Una
     MONEDA, una GEMA y una LLAMA se entienden sin leer, y desde lejos — que es como se mira una
     barra de carrito, de reojo mientras se decide si añadir una cosa más.

     Van dibujados aquí, en vectores, y no como imágenes: pesan bytes en vez de kilobytes, no
     cuestan una petición, y se pintan nítidos en cualquier pantalla y a cualquier tamaño.

     Y SIN `<defs>` ni gradientes con id: en la página del carrito esta barra existe DOS veces —la
     del cajón y la de la página—, y dos ids iguales en un documento hacen que el segundo icono
     herede el relleno del primero. El volumen se consigue por capas de color, que no colisionan
     con nada. */
  var ICONOS = {
    oro:
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10.5" fill="#b8790a"/>' +
      '<circle cx="12" cy="12" r="9" fill="#f0b429"/>' +
      '<circle cx="12" cy="12" r="6.6" fill="#ffdf7a"/>' +
      '<path d="M12 6.4l1.6 3.4 3.7.5-2.7 2.6.7 3.7-3.3-1.8-3.3 1.8.7-3.7-2.7-2.6 3.7-.5z"' +
      ' fill="#a86a06"/>' +
      '<path d="M7 8.2a7 7 0 0 1 4.4-3.1c.5-.1.6.6.1.8A6.2 6.2 0 0 0 7.8 8.7c-.3.4-1-.1-.8-.5z"' +
      ' fill="#fff8dc" opacity=".85"/></svg>',
    diamante:
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M5 4h14l4 5-11 12L1 9z" fill="#5cc9f0"/>' +
      '<path d="M5 4h14l4 5H1z" fill="#bfefff"/>' +
      '<path d="M9.5 4h5l2.5 5H7z" fill="#eafaff"/>' +
      '<path d="M1 9h22l-11 12z" fill="#7fd4f5"/>' +
      '<path d="M7 9h10l-5 12z" fill="#a9e6fb"/>' +
      '<path d="M12 9l5-5 2 5-5 12z" fill="#ffffff" opacity=".35"/></svg>',
    fuego:
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M12.6 1.6c3.2 3.4 4.8 6.2 4.8 8.5 0 1.3-.4 2.3-1.1 3 .9-.2 1.7-.9 2.3-2 '
      + '1.4 1.9 2 3.7 2 5.4 0 4.1-3.5 7.5-8.6 7.5S3.4 20.6 3.4 16.5c0-3 1.6-6.1 4.9-9.3'
      + '-.2 1.6.2 2.9 1.2 3.9.5-3.6 1.5-6.7 3.1-9.5z" fill="#ff7a18"/>' +
      '<path d="M12.2 9.6c1.8 2 2.7 3.7 2.7 5.1 0 2.6-1.6 4.6-3.9 4.6s-3.7-1.7-3.7-4.1'
      + 'c0-1.7.8-3.3 2.4-5-.1 1 .1 1.8.6 2.4.3-1.6.9-2.9 1.9-3z" fill="#ffd166"/>' +
      '<path d="M11.6 14.4c.9 1 1.3 1.9 1.3 2.6 0 1.2-.8 2.1-1.9 2.1s-1.7-.8-1.7-1.9'
      + 'c0-.8.4-1.6 1.1-2.4 0 .5.1.9.3 1.2.2-.7.5-1.4.9-1.6z" fill="#fff6d6"/></svg>'
  };

  /* ── LOS DOS EFECTOS QUE ATRAVIESAN LA BARRA ─────────────────────────────────────────
     Alfredo, 2026-08-20: *"no me gustan el efecto llama, quiero que se sienta toda la barra como
     una llama, como si fuera un asteroide. El oro como si fuera una estrella fugaz."*

     Las llamitas verticales estaban mal pensadas: decoraban el borde del relleno, así que la
     barra seguía siendo una barra con adornos encima. Lo que él pide es que la barra ENTERA sea
     la cosa — que arda, no que lleve fuego puesto.

     Los dos efectos son el mismo gesto a distinta temperatura: algo que CRUZA la barra dejando
     estela. El oro pasa y se va (una estrella fugaz: destello, cola, silencio); el fuego no se va
     nunca (un asteroide entrando: cabeza incandescente y brasas que se desprenden hacia atrás).

     Se construyen aquí y no en CSS puro porque la estela son piezas sueltas con su propio retardo
     — una cola de verdad, no un degradado que finge una. */
  function pintarEfecto(b, est) {
    var lleno = b.querySelector('.envio-lleno');
    if (!lleno) return;
    var premio = b.getAttribute('data-premio');
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var quiere = quieto ? '' : (premio === 'fuego' ? 'asteroide' : premio === 'oro' ? 'fugaz' : '');
    var puesto = lleno.querySelector('.envio-efecto');
    if (puesto && puesto.getAttribute('data-tipo') === quiere) return;   // ya está: no se rehace
    if (puesto && puesto.parentNode) puesto.parentNode.removeChild(puesto);
    if (!quiere) return;
    var capa = document.createElement('span');
    capa.className = 'envio-efecto es-' + quiere;
    capa.setAttribute('data-tipo', quiere);
    var nucleo = document.createElement('b');
    nucleo.className = 'envio-nucleo';
    capa.appendChild(nucleo);
    // La estela: piezas sueltas, cada una un poco más atrás y un poco más tarde. Es lo que hace
    // que se lea como una cola y no como una mancha.
    var trozos = quiere === 'asteroide' ? 7 : 5;
    for (var i = 0; i < trozos; i++) {
      var t = document.createElement('i');
      t.style.animationDelay = (i * 55) + 'ms';
      t.style.setProperty('--i', i);
      capa.appendChild(t);
    }
    lleno.appendChild(capa);
  }

  function pintarHitos(b, est) {
    var riel = b.querySelector('.envio-riel');
    if (!riel) return;
    var capa = riel.querySelector('.envio-hitos');
    if (!capa) {
      capa = document.createElement('span');
      capa.className = 'envio-hitos';
      riel.appendChild(capa);
    }
    var hitos = est.hitos || [];
    var firma = hitos.map(function (h) { return h.pct + ':' + (h.hecho ? 1 : 0); }).join('|');
    if (capa.getAttribute('data-firma') !== firma) {
      capa.setAttribute('data-firma', firma);
      capa.textContent = '';
      for (var i = 0; i < hitos.length; i++) {
        var m = document.createElement('span');
        m.className = 'envio-hito es-' + hitos[i].tipo + (hitos[i].hecho ? ' es-hecho' : '');
        m.style.left = hitos[i].pct + '%';
        // El halo va en su propio elemento, detrás del dibujo: así puede latir sin arrastrar al
        // icono en la animación, y el icono se queda quieto y nítido.
        m.innerHTML = '<b class="envio-halo"></b>' + (ICONOS[hitos[i].tipo] || '');
        capa.appendChild(m);
      }
    }
    // EL MATERIAL DE LA BARRA. Se declara como dato y el CSS lo pinta: así el medidor puede
    // comprobar QUÉ premio muestra sin tener que leer colores.
    b.setAttribute('data-premio', materialDe(est.peldanos || [], est.indice || 0));
    b.classList.add('con-hitos');
    pintarEfecto(b, est);
  }

  /* El tronido. Se dispara solo al SUBIR de peldaño, y con el material del peldaño alcanzado.
     Las chispas se crean y se tiran: dejarlas en el DOM llenaría el carrito de basura invisible
     después de una tarde comprando. */
  function celebrar(b, est) {
    var i = est.indice || 0;
    if (i <= 0 || i <= hitoCelebrado()) return;
    guardarHito(i);
    var tipo = materialDe(est.peldanos || [], i);
    b.classList.remove('truena-oro', 'truena-diamante');
    // Forzar el reflow: sin esto, quitar y poner la clase en el mismo cuadro no reinicia la
    // animación y el segundo tronido no se ve.
    void b.offsetWidth;
    b.classList.add('truena-' + tipo);
    var riel = b.querySelector('.envio-riel');
    var hitos = est.hitos || [], donde = 100;
    for (var k = 0; k < hitos.length; k++) if (hitos[k].indice === i) donde = hitos[k].pct;
    if (riel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // LA ONDA: un anillo que se abre desde el punto exacto donde acaba de cruzar. Es lo que
      // convierte el reventón en un golpe con origen — sin ella las chispas parecen aparecer de
      // la nada, y el ojo no sabe adónde mirar.
      var onda = document.createElement('span');
      onda.className = 'envio-onda es-' + tipo;
      onda.style.left = donde + '%';
      riel.appendChild(onda);
      setTimeout(function () { if (onda.parentNode) onda.parentNode.removeChild(onda); }, 1000);
      var caja = document.createElement('span');
      caja.className = 'envio-chispas es-' + tipo;
      caja.style.left = donde + '%';
      // Cuanto más alto el premio, más grande el reventón: el fuego tiene que sentirse distinto
      // del oro, no ser el mismo puñado de chispas pintado de otro color.
      var cuantas = tipo === 'fuego' ? 20 : tipo === 'diamante' ? 16 : 12;
      for (var j = 0; j < cuantas; j++) {
        var ch = document.createElement('i');
        // Cada chispa sale en su propia dirección: un abanico, no una nube. El ángulo se reparte
        // en abanico hacia arriba, que es de donde el ojo espera que salte algo que revienta.
        ch.style.setProperty('--a', (-170 + j * (170 / Math.max(1, cuantas - 1)) * 2) + 'deg');
        ch.style.setProperty('--d', (26 + (j % 5) * 9) + 'px');
        ch.style.setProperty('--g', (0.6 + (j % 4) * 0.25));   // cada una tarda lo suyo en caer
        ch.style.animationDelay = (j % 4) * 35 + 'ms';
        caja.appendChild(ch);
      }
      riel.appendChild(caja);
      setTimeout(function () { if (caja.parentNode) caja.parentNode.removeChild(caja); }, 1800);
    }
    setTimeout(function () { b.classList.remove('truena-' + tipo); }, 1500);
  }

  function pintarEnvio(c) {
    var E = K.envioGratis || {}, r = envioGratis(c), yaAnuncia = false;
    var est = r && !r.callada ? r : null;
    // SHOPIFY MANDA. Si ya contestó para este carrito, su respuesta pisa a la cuenta del tema en
    // las dos direcciones: confirma el envío gratis aunque el umbral no llegue, y lo desmiente
    // aunque sobre. Es la única forma de que la barra y el pago no puedan contradecirse.
    if (est) {
      preguntarEnvio(c, function () { pintarEnvio(carritoActual || c); });
      var dicho = respuestas[cpGuardado() + ':' + c.total_price];
      if (dicho) {
        est.logrado = dicho.gratis;
        est.deShopify = true;
        if (dicho.gratis) { est.falta = 0; est.pct = 100; }
        else if (est.falta === 0) { est.falta = null; est.pct = 99; }
      }
    }
    [].forEach.call(document.querySelectorAll('.envio-barra'), function (b) {
      b.hidden = !est;
      // El tema DECLARA lo que pintó y el medidor COMPARA — el patrón de `data-total` en la
      // rejilla. Si el medidor tuviera que recalcular el porcentaje, estaría reimplementando
      // justo la fórmula que verifica, y un arnés que se responde a sí mismo no prueba nada.
      if (!est) { b.setAttribute('data-callada', r.callada); return; }
      b.removeAttribute('data-callada');
      b.setAttribute('data-estado', est.logrado ? 'logrado'
        : est.porElCupon ? 'por-cupon' : (est.pct >= 80 ? 'cerca' : 'lejos'));
      b.setAttribute('data-pct', est.pct);
      b.setAttribute('data-falta', est.falta);
      b.setAttribute('data-umbral', est.umbral);
      b.setAttribute('data-total', est.total);   // lo que el cliente ve
      b.setAttribute('data-base', est.base);     // lo que Shopify compara (sin IVA)
      // Una sola región viva, la visible: con dos, el lector de pantalla lee el avance dos veces.
      var msgEl = b.querySelector('.envio-msg');
      if (msgEl) {
        if (!yaAnuncia && !tapado(b)) { msgEl.setAttribute('aria-live', 'polite'); yaAnuncia = true; }
        else { msgEl.removeAttribute('aria-live'); }
      }
      // Tres estados, tres textos. El de «ya casi» es el que más mueve el carrito y hasta hoy
      // decía exactamente lo mismo que «te faltan»: el CSS ya distinguía el momento y el texto no.
      var plantilla = est.logrado ? (E.logrado || TEXTO_LOGRADO)
                    : est.falta === null ? TEXTO_CASI_SIN_CIFRA
                    : est.porElCupon ? TEXTO_POR_CUPON
                    : est.pct >= 80 ? (E.cerca || TEXTO_CERCA)
                    : (E.texto || TEXTO_FALTA);
      var texto = String(plantilla).replace('{falta}', formatoDinero(est.falta));
      // CON ESCALERA, EL PREMIO TIENE PRECIO. «Te faltan $199 para envío gratis» es falso cuando
      // el siguiente peldaño son $99, no cero: se dice lo que de verdad va a pagar si sube.
      if (est.escalera && !est.logrado) {
        texto = 'Te faltan ' + formatoDinero(est.falta) + ' para '
          + (est.precioSiguiente > 0
             ? ('que tu envío baje a ' + formatoDinero(est.precioSiguiente * 100))
             : 'ENVÍO GRATIS');
      } else if (est.escalera && est.logrado) {
        texto = '¡Tu envío es GRATIS! 🎉';
      }
      if (est.escalera) { pintarPeldanos(b, est); pintarHitos(b, est); celebrar(b, est); }
      b.classList.toggle('logrado', est.logrado);
      b.classList.toggle('cerca', !est.logrado && est.pct >= 80);
      var riel = b.querySelector('.envio-riel');
      var lleno = b.querySelector('.envio-lleno');
      if (msgEl) msgEl.textContent = texto;
      if (lleno) lleno.style.width = est.pct + '%';
      if (riel) {
        // `aria-valuetext` para que el lector de pantalla lea «te faltan $340» y no «45».
        riel.setAttribute('aria-valuenow', est.pct);
        riel.setAttribute('aria-valuetext', texto);
      }
    });
  }

  // ── avisos ───────────────────────────────────────────────────────────────
  var avisoTimer = null;
  function aviso(texto, esError) {
    var el = document.getElementById('aviso-carrito');
    if (!el) {
      el = document.createElement('div');
      el.id = 'aviso-carrito'; el.className = 'aviso-carrito';
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    el.appendChild(document.createTextNode(texto));
    if (!esError) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'aviso-ver'; b.textContent = 'Ver carrito';
      b.addEventListener('click', abrir);
      el.appendChild(b);
    }
    el.classList.toggle('error', !!esError);
    el.classList.add('visible');
    clearTimeout(avisoTimer);
    avisoTimer = setTimeout(function () { el.classList.remove('visible'); }, 4200);
  }

  // ── ¿sigue existiendo lo que llevo? ──────────────────────────────────────
  // Shopify NO aparta inventario al agregar al carrito: no existe un estado «en carrito» —
  // los cinco estados son On hand / Available / Committed / Unavailable / Incoming, y solo se
  // pasa a Committed cuando ya HAY una orden. (La reserva de 5 minutos al entrar al pago existió
  // y Shopify la quitó: «there is no longer a reservation on the items when they enter checkout».)
  //
  // O sea que dos clientes pueden llevar la última pieza a la vez, y eso NO es un defecto del
  // tema: es cómo funciona la plataforma. Lo que sí se puede elegir es DÓNDE se entera el que
  // llegó tarde. Sin esto, se entera en el pago, después de teclear su dirección. Con esto, se
  // entera al abrir el carrito, que es el único sitio donde todavía puede hacer algo.
  //
  // No se le quita nada de su carrito: se le avisa. Borrarle cosas sin preguntar es peor que el
  // problema que arregla.
  function revisarDisponibles(c) {
    if (!cuerpo || !c || !c.items || !c.items.length) return;
    var pendientes = c.items.map(function (it) {
      var handle = it.handle || String(it.url || '').split('?')[0].split('/products/')[1] || '';
      if (!handle) return Promise.resolve(null);
      return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return null;
          for (var i = 0; i < p.variants.length; i++) {
            if (String(p.variants[i].id) === String(it.variant_id)) {
              return p.variants[i].available ? null : it.product_title;
            }
          }
          return it.product_title;      // la variante ya ni existe
        })
        .catch(function () { return null; });   // sin red no se asusta a nadie
    });
    Promise.all(pendientes).then(function (idos) {
      var faltan = idos.filter(Boolean);
      var previo = document.getElementById('cajon-agotados');
      if (previo) previo.parentNode.removeChild(previo);
      if (!faltan.length) return;
      var el = document.createElement('p');
      el.id = 'cajon-agotados';
      el.className = 'cajon-agotados';
      el.setAttribute('role', 'status');
      el.textContent = faltan.length === 1
        ? 'Ya no queda «' + faltan[0] + '». Quítalo para poder pagar.'
        : 'Ya no quedan: ' + faltan.join(', ') + '. Quítalos para poder pagar.';
      cuerpo.insertBefore(el, cuerpo.firstChild);
    });
  }

  // ── el cajón ─────────────────────────────────────────────────────────────
  var cajon = document.getElementById('cajon-carrito');
  var fondo = document.getElementById('cajon-fondo');
  var cuerpo = document.getElementById('cajon-cuerpo');
  var pie = document.getElementById('cajon-pie');
  var totalEl = document.getElementById('cajon-total');
  var ultimoFoco = null;

  var carritoActual = null;

  function pintar(c) {
    // `/cart/add.js` devuelve SOLO las líneas agregadas, NO el carrito (doc de la Cart AJAX
    // API; `change.js` y `update.js` sí lo devuelven — la asimetría es la que muerde). Un
    // payload así no trae `total_price`, y pintarlo dejaría el total en «$NaN» y la barra de
    // envío en blanco. Hoy nadie llama por ahí —tras agregar se relee /cart.js—, pero es un
    // atajo de una línea que cualquiera añadiría, y el síntoma no señalaría a este archivo.
    if (!c || typeof c.total_price !== 'number') return;
    carritoActual = c;
    pintarEnvio(c);
    if (!cuerpo) return;
    contador(c.item_count);
    if (!c.items || !c.items.length) {
      cuerpo.innerHTML = '<p class="vacio">' +
        (document.documentElement.lang === 'en' ? 'Your cart is empty' : 'Tu carrito está vacío 🧸') +
        '</p>';
      if (pie) pie.hidden = true;
      return;
    }
    cuerpo.innerHTML = c.items.map(function (it, i) {
      var img = it.image
        ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">'
        : '<span class="cajon-sinimg">🎀</span>';
      var variante = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<div class="cajon-var">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cajon-item" data-linea="' + (i + 1) + '">' +
        '<a class="cajon-img" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div class="cajon-datos">' +
          '<a class="cajon-titulo" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          variante +
          '<div class="precio">' + formatoDinero(it.final_line_price) + '</div>' +
        '</div>' +
        '<div class="cajon-cant">' +
          '<button type="button" data-mas="-1" aria-label="Quitar uno">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-mas="1" aria-label="Añadir uno">+</button>' +
          '<button type="button" class="cajon-quitar" data-quitar="1">Quitar</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (pie) pie.hidden = false;
    if (totalEl) totalEl.textContent = formatoDinero(c.total_price);
    pintarTotales(c);
  }

  // ── EL DESCUENTO SE VE EN EL CAJÓN ────────────────────────────────────────
  // Alfredo, 2026-07-28: *"en mi carrito no se ve la operación de descuento, sigue apareciendo el
  // «tienes un cupón» en lugar de mostrar un mensaje como cupón aplicado"*. Tenía razón dos veces:
  // el cajón no enseñaba el descuento en ningún lado —solo el total, sin decir de dónde salía— y
  // la fila seguía invitando a hacer algo que ya estaba hecho. Un carrito que no muestra su
  // descuento obliga a confiar; enseñarlo es la diferencia entre creer y ver.
  // EL MONTO NO SE SUMA: SE LEE. Alfredo, 2026-07-28: *"cuando ya se alcanzó el límite me da un
  // descuento distinto, y después de 4 también pasa, se corrige cuando se vuelve a aumentar la
  // cantidad… esto lleva a confusión y a enojo por parte de los clientes"*.
  //
  // La versión anterior SUMABA dos sitios: `cart_level_discount_applications[].total_allocated_
  // amount` y `items[].discounts[].amount`. Un descuento de carrito se REPARTE entre las líneas,
  // así que ese mismo dinero aparece en los dos lados y se contaba dos veces — y con cantidades
  // que no reparten exacto, el redondeo del reparto hacía que el error cambiara con cada unidad.
  // De ahí que a 4 se viera mal y a 6 «se arreglara»: no se arreglaba, coincidía.
  //
  // `total_discount` es, en la referencia del Ajax API (shopify.dev/docs/api/ajax/reference/cart,
  // leída el 2026-07-28), «lo que se dedujo del precio original del carrito por TODOS los
  // descuentos aplicados». Un solo número, ya sumado por Shopify, imposible de contar dos veces.
  // Si faltara, la resta `original_total_price − total_price` dice lo mismo por aritmética: lo
  // que iba a costar menos lo que cuesta. Nunca se vuelve a sumar a mano lo que ya viene sumado.
  function descuentoDe(c) {
    var monto = (c && typeof c.total_discount === 'number') ? c.total_discount : 0;
    if (!monto && c && typeof c.original_total_price === 'number'
        && typeof c.total_price === 'number') {
      monto = Math.max(0, c.original_total_price - c.total_price);
    }
    var apps = (c && c.cart_level_discount_applications) || [];
    // Tercer respaldo, por si un payload viniera sin totales (p. ej. una respuesta recortada):
    // las aplicaciones de carrito SOLAS. Nunca se les suma lo de las líneas — es el mismo dinero
    // repartido, y sumarlo es exactamente el defecto que este orden existe para no repetir.
    if (!monto) {
      monto = apps.reduce(function (s, d) { return s + (d.total_allocated_amount || 0); }, 0);
    }
    var nombre = (apps[0] && (apps[0].title || apps[0].code)) || '';
    if (!nombre) {
      (c && c.items || []).some(function (it) {
        var d = (it.line_level_discount_allocations || [])[0];
        var t = (d && d.discount_application && (d.discount_application.title
                 || d.discount_application.code))
             || ((it.discounts || [])[0] || {}).title || '';
        if (t) nombre = t;
        return !!t;
      });
    }
    return { monto: monto, nombre: nombre, hay: monto > 0 };
  }

  // LAS TRES CIFRAS, NO UNA. Alfredo, 2026-07-28: *"debe haber un total de suma de productos,
  // un total del descuento, y un total del producto + el descuento, y este último es el que da el
  // envío gratis"*. Con un solo número no se puede saber cuál cuenta para los $1 000, y quien no
  // lo sabe o compra de más o se enoja al ver que no se cumplió.
  //
  // CUÁL MIDE EL ENVÍO GRATIS: el de abajo, el ya descontado. La documentación de Shopify NO dice
  // si sus condiciones de envío miran antes o después del descuento (buscado el 2026-07-28 en las
  // dos páginas de tarifas), así que se toma el lado que NO puede prometer de más: si midiéramos
  // el subtotal sin descontar, la barra cantaría «envío gratis» y el checkout podría cobrarlo —
  // que es exactamente el enojo que se quiere evitar. Prometer de menos molesta; prometer de más
  // rompe la confianza.
  function pintarTotales(c) {
    if (!pie) return;
    var d = descuentoDe(c);
    var caja = document.getElementById('cajon-totales');
    if (!d.hay) { if (caja) caja.remove(); return; }
    if (!caja) {
      caja = document.createElement('div');
      caja.id = 'cajon-totales';
      pie.insertBefore(caja, document.querySelector('.cajon-total'));
    }
    var sub = (typeof c.original_total_price === 'number')
      ? c.original_total_price : (c.total_price || 0) + d.monto;
    caja.innerHTML =
      '<div class="cajon-linea"><span>Productos</span><span>' + formatoDinero(sub) + '</span></div>'
      + '<div class="cajon-linea cajon-descuento"><span>✓ ' + esc(d.nombre || 'Descuento')
      + '</span><span>−' + formatoDinero(d.monto) + '</span></div>';
  }

  function cargar() {
    // K.demo solo existe en la vista previa local de amigo (no hay Shopify detrás). En la
    // tienda real el flag no está y este camino nunca corre.
    if (K.demo) return Promise.resolve(pintar(K.demo));
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(pintar)
      .catch(function () { /* sin red el cajón queda como estaba: no se rompe la página */ });
  }

  function abrir() {
    if (!cajon) { window.location.href = '/cart'; return; }
    ultimoFoco = document.activeElement;
    cajon.hidden = false; if (fondo) fondo.hidden = false;
    document.body.classList.add('cajon-abierto');
    requestAnimationFrame(function () { cajon.classList.add('visible'); if (fondo) fondo.classList.add('visible'); });
    // Al ABRIR se revisa, no en cada carga de página: es el momento en que la persona mira su
    // carrito, y es una petición por producto — barato aquí, caro si se hiciera en cada pantalla.
    cargar().then(function () { revisarDisponibles(carritoActual); });
    var cerrarBtn = document.getElementById('cajon-cerrar');
    if (cerrarBtn) cerrarBtn.focus();
  }

  function cerrar() {
    if (!cajon) return;
    cajon.classList.remove('visible'); if (fondo) fondo.classList.remove('visible');
    document.body.classList.remove('cajon-abierto');
    setTimeout(function () { cajon.hidden = true; if (fondo) fondo.hidden = true; }, 300);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  // Sin este candado, dos clics rápidos mandan el MISMO número de línea y el segundo borra
  // otro producto: después de la primera respuesta las líneas se recorren.
  var ocupado = false;
  function cambiar(linea, cantidad) {
    if (ocupado) return;
    ocupado = true;
    if (cuerpo) cuerpo.classList.add('trabajando');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      // Shopify contesta 422 cuando la cantidad pedida pasa del inventario, y ese cuerpo NO es
      // un carrito: no trae `items` ni `total_price`. Pintarlo dejaba el cajón diciendo «Tu
      // carrito está vacío» con el producto todavía dentro — el defecto que reportó Alfredo el
      // 2026-07-27. Se enseña LO QUE DIJO SHOPIFY (sabe cuántas quedan; nosotros no) y se vuelve
      // a leer el carrito de verdad, para que el número en pantalla no quede inventado.
      if (!res.ok) {
        aviso(res.d.description || res.d.message || 'No se pudo actualizar el carrito', true);
        return cargar();
      }
      pintar(res.d);
    }).catch(function () { aviso('No se pudo actualizar el carrito', true); })
      .then(function () { ocupado = false; if (cuerpo) cuerpo.classList.remove('trabajando'); });
  }

  // El botón flotante abre el cajón en vez de navegar (pero sigue siendo un enlace real).
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;          // click sobre texto suelto o el documento
    if (t.closest('a.flotante-carrito, a.carrito-enlace') && cajon) {
      ev.preventDefault(); abrir(); return;
    }
    if (t.closest('#cajon-cerrar') || t.closest('#cajon-fondo')) { cerrar(); return; }

    var item = t.closest('.cajon-item');
    if (!item) return;
    var linea = parseInt(item.getAttribute('data-linea'), 10);
    var cant = parseInt(item.querySelector('.cajon-cant span').textContent, 10) || 1;
    if (t.closest('[data-quitar]')) return void cambiar(linea, 0);
    var mas = t.closest('[data-mas]');
    if (mas) cambiar(linea, Math.max(0, cant + parseInt(mas.getAttribute('data-mas'), 10)));
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && cajon && !cajon.hidden) cerrar();
  });

  // ── el tope que Shopify NO pone al agregar ───────────────────────────────
  // Medido contra la tienda el 2026-07-27, con UNA unidad en inventario: `/cart/change.js`
  // devuelve 422 al pedir 2, pero `/cart/add.js` aceptó OCHO veces seguidas y el carrito quedó
  // en 8. O sea que subir cantidad desde el cajón está protegido y agregar desde la rejilla no.
  // Quien se lleva el golpe es el cliente, en el pago, después de haberse ilusionado.
  // El tope lo declara el tema desde Liquid (`data-tope`), y solo cuando el inventario se
  // cuenta Y la tienda dice que NO se vende sin existencias: si Alfredo activa preventa, este
  // freno desaparece solo, sin tocar código.
  function topeDe(f) {
    var el = f.querySelector('[name=id]');
    if (el && el.tagName === 'SELECT') el = el.options[el.selectedIndex];
    var v = el && el.getAttribute('data-tope');
    return v === null || v === undefined || v === '' ? -1 : parseInt(v, 10);
  }

  function yaEnCarrito(idVariante) {
    var n = 0, its = (carritoActual && carritoActual.items) || [];
    for (var i = 0; i < its.length; i++) {
      if (String(its[i].variant_id) === String(idVariante)) n += its[i].quantity;
    }
    return n;
  }

  // ── agregar sin salir de la página ───────────────────────────────────────
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    ev.preventDefault();
    var tope = topeDe(f);
    if (tope >= 0) {
      var elId = f.querySelector('[name=id]');
      var idVar = elId && (elId.tagName === 'SELECT' ? elId.value : elId.value);
      var pide = parseInt((f.querySelector('[name=quantity]') || {}).value, 10) || 1;
      var lleva = yaEnCarrito(idVar);
      if (lleva + pide > tope) {
        aviso(tope <= 0 ? 'Se acaba de agotar 😢'
              : lleva >= tope ? 'Ya llevas las ' + tope + ' que quedan'
              : 'Solo quedan ' + (tope - lleva) + ' disponibles', true);
        return;
      }
    }
    var boton = f.querySelector('[type=submit]');
    var antes = boton ? boton.textContent : '';
    if (boton) { boton.disabled = true; boton.textContent = '…'; }
    function restaurar() { if (boton) { boton.disabled = false; boton.textContent = antes; } }

    // ── PREVENTA: SE PREGUNTA ANTES DE AGREGAR ─────────────────────────────
    // Alfredo, 2026-08-19: *"al agregar ese producto lanzar un alertdialog donde indican que
    // aceptan los términos y condiciones"*.
    //
    // Va AQUÍ y no en un segundo interceptor de `submit`: dos manejadores del mismo evento es
    // cómo uno agrega y el otro cree que no. Este archivo es el único que manda al carrito, así
    // que la pregunta tiene que caer en su camino.
    //
    // La aceptación viaja como propiedad de LA LÍNEA (`properties[Preventa]`): así queda en el
    // pedido, pegada al producto que la necesitaba, y Alfredo la ve al prepararlo. Una nota de
    // carrito valdría para todo el pedido y no diría cuál de los productos era el de preventa.
    var _pvApi = window.BKB_PREVENTA;
    var _pv = _pvApi ? _pvApi.de(_pvApi.handleDe(f)) : null;
    if (_pv) {
      _pvApi.preguntar(_pv).then(function (acepto) {
        if (!acepto) { aviso('No se agregó: la preventa necesita tu confirmación.'); restaurar(); return; }
        var d = new FormData(f);
        d.append('properties[Preventa]',
                 (_pv.aviso_envio || 'Preventa') + ' · aceptada ' + new Date().toISOString().slice(0, 10));
        agregar(d);
      });
      return;
    }
    agregar(new FormData(f));

    function agregar(cuerpo) {
    fetch('/cart/add.js', { method: 'POST', body: cuerpo,
                            headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {   // Shopify explica por qué (sin stock, variante mala): se muestra tal cual
          aviso(res.d.description || res.d.message || 'No se pudo agregar', true);
          restaurar(); return;
        }
        aviso('🛒 ' + (res.d.title || 'Agregado') + ' — listo');
        if (boton) boton.textContent = '✓';
        setTimeout(restaurar, 1200);
        return cargar();
      })
      .catch(function () { aviso('No se pudo agregar. Revisa tu conexión.', true); restaurar(); });
    }
  });

  cargar();   // el contador arranca con la cifra real
})();


/* ── EL CUPÓN GANADO SE APLICA SOLO ─────────────────────────────────────────────────────────────
   Alfredo, 2026-07-28: *"lo que busco es la aplicación automática del cupón después de ganar"*, y
   luego *"sigue siendo manual el cupón"*.

   `/discount/<código>` es el enlace de descuento de Shopify: hay que NAVEGAR a él. Pedido con
   `fetch` por detrás no deja el descuento puesto — eso ya se midió.

   LO QUE FALLABA EN MI PRIMERA VERSIÓN: se marcaba `aplicado=1` ANTES de navegar, para no hacer
   un bucle… y no se comprobaba nunca si de verdad había entrado. Un intento fallido dejaba el
   cupón marcado como puesto y la persona, manual para siempre. La marca optimista es lo que hay
   que arreglar, no el bucle.

   CÓMO QUEDA:
   · ir a PAGAR siempre pasa por `/discount/` mientras el cupón viva. Volver a aplicarlo es
     idempotente y cuesta lo mismo; el momento de pagar es el único que no se puede fallar.
   · en la página del carrito se intenta, y al volver se COMPRUEBA en el carrito real. Si entró,
     se marca de verdad. Si no, se reintenta una vez más y luego se deja en paz, para no mandar
     a nadie de viaje sin fin.
   · nunca mientras navega: solo en el carrito y al pagar. Un automatismo no puede secuestrar la
     navegación de nadie. */
(function () {
  var LLAVE_CUPON = 'kawaii_cupon', TOPE_INTENTOS = 2;

  function leer() {
    try { return JSON.parse(localStorage.getItem(LLAVE_CUPON) || 'null'); }
    catch (e) { return null; }
  }
  function guardar(c) {
    try { localStorage.setItem(LLAVE_CUPON, JSON.stringify(c)); } catch (e) { }
  }
  function olvidar() { try { localStorage.removeItem(LLAVE_CUPON); } catch (e) { } }

  function vivo(c) {
    if (!c || !c.codigo) return false;
    if (!c.vence) return true;
    var fin = Date.parse(c.vence);
    if (fin && Date.now() > fin) { olvidar(); return false; }
    return true;
  }

  function tieneDescuento(carrito) {
    return !!(carrito && ((carrito.cart_level_discount_applications || []).length
      || (carrito.items || []).some(function (i) { return (i.discounts || []).length; })));
  }

  function irAplicando(codigo, destino) {
    window.location.href = '/discount/' + encodeURIComponent(codigo)
      + '?redirect=' + encodeURIComponent(destino);
  }

  function enCarrito() {
    return /(^|\/)cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  // ── en la página del carrito: intentar, y luego COMPROBAR ──
  function aplicarEnCarrito() {
    if (!enCarrito()) return;
    var c = leer();
    if (!vivo(c) || c.aplicado) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito || !carrito.item_count) return;   // sin nada dentro no hay qué descontar
        if (tieneDescuento(carrito)) { c.aplicado = 1; guardar(c); return; }
        c.intentos = (c.intentos || 0) + 1;
        guardar(c);                                     // se guarda ANTES: nunca un bucle sin fin
        if (c.intentos <= TOPE_INTENTOS) irAplicando(c.codigo, '/cart');
      })
      .catch(function () { });
  }

  // ── al PAGAR: siempre, mientras el cupón viva ──
  // Aquí NO se mira `aplicado`: es la última oportunidad, y una marca equivocada costaría el
  // premio entero. Re-aplicar no puede dejarlo peor.
  // AL PAGAR SE APLICA EL CUPÓN, PERO NO SE SECUESTRA EL CLIC. La primera versión hacía
  // `preventDefault()` en FASE DE CAPTURA y navegaba: con eso le ganaba al panel de dirección
  // —que engancha ese mismo botón para abrirse y armar el permalink con la dirección del
  // cliente— y lo dejaba sin efecto. Alfredo, 2026-07-28: *"ir a pagar ya no me lleva al
  // formulario donde me completaba mi dirección con el permalink"*. Le quité una función suya
  // sin darme cuenta, arreglando otra.
  //
  // Un automatismo que pisa a otro no es un arreglo, es un cambio de defecto. Ahora el cupón se
  // aplica POR DETRÁS —el mismo marco invisible del botón del premio, que es una navegación de
  // verdad sin mover a nadie— y el clic sigue su camino intacto: el panel de dirección se abre
  // como siempre y, para cuando la persona termina de escribir su dirección, el descuento lleva
  // rato puesto en la sesión.
  function alPagar() {
    document.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest && ev.target.closest('[name="checkout"]');
      if (!b) return;
      var c = leer();
      if (!vivo(c)) return;
      aplicarPorDetras(c.codigo);          // sin preventDefault: NO se toca lo que iba a pasar
    }, true);
  }

  // Navegación de verdad dentro de un marco invisible: `/discount/…` solo hace efecto navegando
  // (un `fetch` no deja el descuento puesto, medido), y así no se mueve a nadie de su página ni
  // se interrumpe lo que estaba haciendo.
  function aplicarPorDetras(codigo) {
    var marco = document.createElement('iframe');
    marco.setAttribute('aria-hidden', 'true');
    marco.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px';
    marco.src = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart.js';
    document.body.appendChild(marco);
    setTimeout(function () { try { marco.remove(); } catch (e) { } }, 8000);
  }

  function arrancar() { aplicarEnCarrito(); alPagar(); }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', arrancar);
  else
    arrancar();
})();
